import { graphql } from "./generated/index.js"

export const insertType = graphql(`
  mutation insertType($object: types_insert_input!) {
    insert_types_one(object: $object) {
      ...TypeFields
    }
  }
`)

export const updateType = graphql(`
  mutation updateType($name: String!, $_set: types_set_input!) {
    update_types_by_pk(pk_columns: { name: $name }, _set: $_set) {
      ...TypeFields
    }
  }
`)
